import {
  first,
  get,
  isArray,
  isEmpty,
  keyBy,
  last,
  range,
  sortBy,
} from "lodash";
import { IEmployeeCalendar } from "src/Pages/Company/Absences/AbsenceRecords/AbsenceRecords.models";
import {
  ICalendar,
  ISortedCalendarsOptions,
} from "src/Pages/Company/Absences/Calendars/Calendars.models";

const transformToOption = (calendar: ICalendar) => ({
  id: calendar.id,
  label: calendar.name,
});

/**
 * Function transforming default API calendars data to structure ready to use in MUI Autocomplete.
 * @param {array} data - collection of calendars from API.
 * @returns {array} - array of autocomplete options.
 */
export const transformCalendarsToOptions = (data: ICalendar[]) => {
  if (!isArray(data)) return {};

  return data.reduce((acc: ISortedCalendarsOptions, calendar: ICalendar) => {
    const { year } = calendar;
    if (!acc[year]) {
      acc[year] = [];
    }
    acc[year].push(transformToOption(calendar));

    return acc;
  }, {});
};

/**
 * Function transforming API calendars data to structure ready to use in hook-form default values.
 * @param {array} employeeCalendars - collection of calendars from API.
 * @param {array} years - collection of given years.
 */
export const getInitialCalendars = (
  employeeCalendars: IEmployeeCalendar[] | undefined,
  years: string[]
) => {
  if (!employeeCalendars || isEmpty(employeeCalendars)) {
    return years.map((year) => ({
      year,
      calendarId: null,
    }));
  }

  const sortedCalendars = sortBy(employeeCalendars, (calendar) =>
    parseInt(calendar.year, 10)
  );
  const calendarMap = keyBy(sortedCalendars, "year");

  const minYear = parseInt(first(sortedCalendars)!.year, 10);
  const maxYear = parseInt(last(sortedCalendars)!.year, 10);

  return range(minYear, maxYear + 1).map((year) => {
    const yearStr = year.toString();

    return {
      year: yearStr,
      calendarId: get(calendarMap, [yearStr, "calendarId"], null),
    };
  });
};
